import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react'

import { AppSidebarNav } from './AppSidebarNav'

import divelogo from 'src/assets/images/dive_logo.png'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css' 

const style = { 
  '--cui-sidebar-bg': '#5A70F7',
}

// sidebar nav config
import navigation from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CSidebar
      style={style}
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex justify-content-start" to="/">
        <img className='me-2 ms-3' src ={divelogo} height={35}></img>
        <strong>Dive</strong><span>Wallet</span>
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
     
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
